import React, { useState } from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  IconButton,
  CircularProgress,
} from "@mui/material";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";

const CardComponent = ({
  cardBalance,
  cardDetails,
  fetchCardDetails,
  fetchCardBalance,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleRefresh = async () => {
    setIsLoading(true);
    await fetchCardBalance();
    setIsLoading(false);
  };

  return (
    <React.Fragment>
      <Card
        sx={{
          width: "100%",
          maxWidth: 450,
          mx: "auto", // center the card
          px: { xs: 1.5, sm: 2 }, // small horizontal padding on mobile, slightly more on larger screens
          borderRadius: 2,
          boxShadow: 1,
          bgcolor: "background.paper",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        elevation={1}
      >
        <CardContent sx={{ flexGrow: 1, p: 0 }}>
          {isLoading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
              sx={{
                px: 2,

                pt: 2,
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{
                bgcolor: "rgba(255,255,255,0.7)",
                borderRadius: 2,
                height: "100%",
                px: 2,
                //  py: 2,
                pt: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {/* Top Logos */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Box
                  component="img"
                  src="/images/formax-pay-logo.png"
                  alt="Logo"
                  sx={{
                    width: 120,
                    maxHeight: 40,
                    objectFit: "contain",
                  }}
                />
                <Box
                  component="img"
                  src="/images/pine-labs-logo.png"
                  alt="Pine Labs"
                  sx={{
                    width: 70,
                    maxHeight: 40,
                    objectFit: "contain",
                  }}
                />
              </Box>

              {/* Cardholder Name */}
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ letterSpacing: 1, mb: 0.5 }}
              >
                {cardDetails?.customer_name || ""}
              </Typography>

              {/* Card Number */}
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ letterSpacing: 2, mb: 1 }}
              >
                {cardDetails?.masked_card_number || ""}
              </Typography>

              {/* Valid Through & CVV - Same Row Like Screenshot */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 1,
                }}
              >
                <Typography variant="body2" color="textPrimary">
                  Valid Till: {cardDetails?.expiry_date || ""}
                </Typography>
                <Typography variant="body2" color="textPrimary">
                  CVV: {"***"}
                </Typography>
              </Box>

              {/* Balance + Refresh */}
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Typography variant="h6" fontWeight="bold">
                  ₹{cardBalance?.available_balance || "0"}
                </Typography>
                <IconButton
                  onClick={handleRefresh}
                  sx={{ ml: 1 }}
                  disabled={isLoading}
                  aria-label="refresh balance"
                >
                  <RefreshRoundedIcon color="primary" />
                </IconButton>
              </Box>

              {/* View Button + RuPay Logo */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: 1, // previously "auto"
                }}
              >
                <Button
                  variant="outlined"
                  color="success"
                  sx={{ borderRadius: 2 }}
                  onClick={() => {
                    if (cardDetails != null) {
                      window.open(cardDetails.card_link, "_blank");
                    }
                  }}
                >
                  View Card Details
                </Button>
                <Box
                  component="img"
                  src="/images/rupay-logo.png"
                  alt="Rupay"
                  sx={{ width: 70, maxHeight: 35, objectFit: "contain" }}
                />
              </Box>
            </Box>
          )}
        </CardContent>
      </Card>

      <div className="text-center pt-3">
        <small className="text-muted d-block" style={{ fontSize: "10px" }}>
          ISSUED BY
        </small>
        <img
          src="/images/pine-labs-logo.png"
          alt="Pine Labs"
          style={{ height: "14px" }}
        />
      </div>
    </React.Fragment>
  );
};

export default CardComponent;
